module.exports = __webpack_public_path__ + "static/14d6f796-9b05-442c-8202-87ae6964a894-a0cef83ac1f1ebbf116f58362c903f56.jpg";